import { createContext, useContext } from "react";

const DrawerCloseContext = createContext<() => void>(() => {});

const useCloseDrawer = () => useContext(DrawerCloseContext);

export { DrawerCloseContext, useCloseDrawer };
